export enum PurchaseType {
  SHOP = "shop",
  LIMITED_EDITION = "limited_edition",
  ELITE_ITEM = "elite_item",
  PLAYERS_MARKET_BUY_FEE = "players_market_buy_fee",
  PLAYERS_MARKET_OFFER_FEE = "players_market_offer_fee",
  MINT = "mint",
}
